<template>
  <b-overlay
    :show="showOverlay"
    opacity="0.5"
    :variant="$store.state.appConfig.layout.skin"
    rounded="sm"
  >
    <!-- Table Container Card -->
    <b-card

      v-if="user.is_admin"
      no-body
    >
      <div>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <!-- Per Page -->
              <list-per-page
                :total="total"
                :current-per-page="perPage"
                @onChangePerPage="changePerPage"
              />
            </b-col>
            <!-- Search -->
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <list-search @onSearch="search" />
              </div>
            </b-col>
          </b-row>
        </div>
        <table-loader v-if="loader" />
        <accounts-list
          v-else
          :fields="fields"
          :items="items"
          :sort-key="sortKey"
          :sort-type="sortType"
          :additional-data="additionalData"
          :list-filters="additionalData.filters"
          :filters="filters"
          @onSortByChange="changeSortKey"
          @onSortDescChange="changeSortType"
          @onFilterChange="filterChange"
          @onFilterButtonClicked="getData"
          @onDeleteButtonClicked="deleteButtonClicked"
          @onRestartButtonClicked="restartAccount"
          @onScreenshotButtonClicked="takeScreenshot"
          @onSendAccountConnectMessageClicked="sendAccountConnectMessage"
        />

        <list-pagination
          :current="page"
          :current-per-page="perPage"
          :from="from"
          :to="to"
          :total="total"
          :total-page="totalPage"
          @onChangePage="changePage"
        />
      </div>
    </b-card>
    <accounts-grid
      v-else
      :items="items"
      @onDeleteButtonClicked="deleteButtonClicked"
    />
  </b-overlay>
</template>

<script>
import { ListIndex } from '../../common/mixins/list'
import AccountsGrid from '../../components/accounts/list/AccountsGrid'
import AccountsList from '../../components/accounts/list/AccountsList'

export default {
  components: {
    AccountsList,
    AccountsGrid,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'accounts',
      sortKey: 'restart_at',
      adminFields: [
        {
          key: 'id',
          label: this.$t('Id'),
          sortable: true,
        },
        {
          key: 'user',
          label: this.$t('User'),
        },
        {
          key: 'name',
          label: this.$t('Account name'),
        },
        {
          key: 'type',
          label: this.$t('Account type'),
        },
        {
          key: 'status',
          label: this.$t('status'),
        },
        {
          key: 'server_status',
          label: this.$t('Server status'),
        },
        {
          key: 'restart_at',
          label: this.$t('Restart at'),
        },
        {
          label: '',
          key: 'action',
        },
      ],
    }
  },
  methods: {
    restartAccount(item) {
      this.showConfirmDialog().then(() => {
        this.showOverlay = true
        this.$http.put(`accounts/${item.id}/restart`).then(() => {
          this.showOverlay = false
        }).catch(() => {
          this.showOverlay = false
        })
      })
    },
    sendAccountConnectMessage(item) {
      this.showConfirmDialog().then(() => {
        this.showOverlay = true
        this.$http.put(`accounts/${item.id}/send-connect-message`).then(() => {
          this.showOverlay = false
        }).catch(() => {
          this.showOverlay = false
        })
      })
    },
    takeScreenshot(item) {
      this.showOverlay = true
      this.$http.get(`accounts/${item.id}/screenshot`).then(({ data }) => {
        window.open(data, '_blank').focus()
        this.showOverlay = false
      }).catch(() => {
        this.showOverlay = false
      })
    },
  },
}
</script>

<style lang="scss">

</style>
